<template>
    <van-popup  teleport=".wrapper" v-model="show" @click="show = false"  :overlay-style="{  backdropFilter: 'blur(10px)'}">
        <div class="guide"></div>
    </van-popup>
</template>

<script>
export default {
    components: {
    },
    props: [''],
    data() {
        return {
            show:false,
        };
    },
    watch: {
    },
    computed: {},
    methods: {
    },
    created() {},
    mounted() {},
};
</script>
<style scoped lang="scss">
.van-popup {
    /* width: 100% !important;
    height: 100vh !important;
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    height: 6.1rem; */
    background-color: transparent;
    position: fixed;
    z-index: 501;
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    // backdrop-filter: blur(5px);
}
.content{
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.guide{
    width: 3.74rem;
    height: 2.86rem;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/guide.png);
    position: fixed;
    right: 0;
    top: 0;
}
.cancel{
    width: .39rem;
    height: .49rem;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/cancel.png);
    position: absolute;
    top: -1rem;
    right: -.1rem;
}
.codeBox{
    width: 6.54rem;
    min-height: 6.83rem;
    border-radius: .65rem;
    padding: .2rem 0;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    .introduce{
        width: 4.1rem;
        font-size: .46rem;
        color: #194769;
        font-family: DingTalkJinBuTi;
        text-align: center;  
    }
    
    .title{
        width: 4.1rem;
        font-size: .46rem;
        color: #194769;
        font-family: DingTalkJinBuTi;
        text-align: center;
    }
    .codeBox2{
        width: 6.03rem;
        height: 2.73rem;
        background-color: #F8F8F8;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: .23rem;
        img{
            max-width: 6.03rem;
            height: auto;
        }
    }
    .tipsTitle{
        width: 5.75rem;
        font-size: .28rem;
        color: #194769;
        margin-top: .23rem;
        font-family: SourceHanSansCNMedium;
        font-weight: bold;
    }
    .details{
        width: 5.75rem;
        font-size: .28rem;
        color: #63849D;

    }

    // .code{
    //     width: 6.5rem;
    //     height: 2.8rem;
    // }
}
</style>